import { render, staticRenderFns } from "./PendingCheckBox.vue?vue&type=template&id=b50e42d0&"
import script from "./PendingCheckBox.vue?vue&type=script&lang=js&"
export * from "./PendingCheckBox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports